module.exports = __webpack_public_path__ + "media/images/upload-a55d6b649f8b28c6e47137d82d8cc070.svg";